import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeUp, Eyebrow } from '../motion';
import { useT } from '../../i18n/LangContext';

export default function ThankYou() {
  const t = useT();

  return (
    <section data-testid="thank-you-section" className="relative overflow-hidden bg-ink py-24 md:py-32">
      <div className="pointer-events-none absolute inset-0" style={{ background: 'radial-gradient(ellipse 50% 60% at 28% 50%, rgba(201,162,39,0.12), transparent 70%)' }} />
      <div className="container-site relative z-10 grid items-center gap-14 lg:grid-cols-2">
        <FadeUp>
          <div className="relative mx-auto max-w-md" style={{ transform: 'rotate(-2deg)' }}>
            <span className="absolute -top-3 left-8 z-10 h-7 w-24 rotate-[-8deg] bg-gold/80 shadow-sm" aria-hidden="true" />
            <span className="absolute -top-3 right-8 z-10 h-7 w-24 rotate-[6deg] bg-gold/80 shadow-sm" aria-hidden="true" />
            <img data-testid="thank-you-note-img" src="/work/thank-you-note.jpg" alt={t['ty.attrib']}
              className="w-full rounded-sm border-8 border-white shadow-[0_30px_60px_-15px_rgba(0,0,0,0.7)]" loading="lazy" />
          </div>
        </FadeUp>
        <FadeUp delay={0.15}>
          <Eyebrow>{t['ty.eyebrow']}</Eyebrow>
          <h2 className="mt-4 font-serif text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            {t['ty.h2']}
          </h2>
          <blockquote className="mt-8 border-l-2 border-gold pl-6 font-serif text-2xl italic leading-relaxed text-white/90 md:text-3xl">
            {t['ty.note']}
          </blockquote>
          <p className="mt-5 max-w-md text-sm leading-relaxed text-silver">{t['ty.attrib']}</p>
          <Link data-testid="thank-you-cta" to="/reviews" className="ghost-btn mt-8">
            {t['ty.cta']} <ArrowRight className="h-4 w-4" />
          </Link>
        </FadeUp>
      </div>
    </section>
  );
}
